import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import mapStyleDarkIcon from '@atom/components/common/svgIcons/mapStyleDark.svg';
import mapStyleRetroIcon from '@atom/components/common/svgIcons/mapStyleRetro.svg';
import mapStyleSilverIcon from '@atom/components/common/svgIcons/mapStyleSilver.svg';
import mapStyleStandardIcon from '@atom/components/common/svgIcons/mapStyleStandard.svg';
import { Icon, Popover, Tooltip } from '@atom/mui';
import { ArrowDropDownIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { MapStyle } from '@atom/types/map';
import { capitalize } from '@atom/utilities/stringUtilities';

import { useAtomMap } from '../AtomMapProvider';

import classes from './toolbar.module.css';

const ALL_STYLES: MapStyle[] = ['default', 'silver', 'dark', 'retro'];

const STYLE_ICONS: Record<MapStyle, string> = {
  default: mapStyleStandardIcon,
  silver: mapStyleSilverIcon,
  dark: mapStyleDarkIcon,
  retro: mapStyleRetroIcon,
};

const StyleControls = () => {
  const { preferences, dispatch } = useAtomMap();
  const anchor = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(false);

  const handleSelect = (mapStyle: MapStyle) => (event: React.MouseEvent) => {
    event.stopPropagation();
    setOpen(false);
    dispatch({ type: 'SET_STYLE', mapStyle });
  };

  return (
    <div className={classes.styleTooltipWrapper} data-cy="atomMapStyleControls">
      <Tooltip title={open ? '' : 'Map Styles'} placement="bottom-end">
        <div
          data-cy="atomMapStylePickerButton"
          className={classes.styleControl}
          ref={anchor}
          onClick={() => setOpen(true)}
        >
          <img src={STYLE_ICONS[preferences.mapStyle]} />
          <Icon
            style={{ color: colors.neutral.gray }}
            icon={ArrowDropDownIcon}
          />
        </div>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchor.current}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        onClose={() => setOpen(false)}
      >
        <div className={classes.styleMenu}>
          {ALL_STYLES.map(style => (
            <div
              key={style}
              className={clsx(
                classes.styleRow,
                preferences.mapStyle === style && classes.styleRowSelected,
              )}
              onClick={handleSelect(style)}
              data-cy={`atomMapStyle-${style}`}
            >
              <img className={classes.styleRowIcon} src={STYLE_ICONS[style]} />
              {capitalize(style)}
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
};

export default StyleControls;
